module.exports = __webpack_public_path__ + "media/paliwa/on-c6d741cf.png";